<template>

    <form ref="estagioavaliacao-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-8">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" name="nome" maxlength="100" placeholder="Nome" v-model="model.nome" required />
            </div>
            <div class="form-group col-md-4">
                <label for="unidade">Unidade</label>
                <input type="text" class="form-control" name="unidade" maxlength="20" placeholder="Unidade" v-model="model.unidade" />
            </div>
            <div class="form-group col-md-12">
                <label for="nomeTraduzido">Nome Traduzido</label>
                <input type="text" class="form-control" maxlength="150" name="nome" placeholder="Nome Traduzido" v-model="model.nomeTraduzido" required />
            </div>
            <div class="form-group col-md-4">
                <label for="tipoAvaliacaoId">Tipo de Avaliação</label>
                <select v-select="{ dataitem: 'TipoAvaliacao', default: 'Selecione' }" v-model="model.tipoAvaliacaoId" class="form-control" name="tipoAvaliacaoId" required></select>
            </div>
            <div class="form-group col-md-4">
                <label for="ordem">Ordem</label>
                <input type="number" class="form-control" min="0" name="ordem" placeholder="Ordem" v-model="model.ordem" required />
            </div>
            <div class="form-group col-md-4">
                <label for="pontuacao">Pontuação</label>
                <input type="text" class="form-control" name="pontuacao" placeholder="Pontuacao" v-model="model.pontuacao" required />
            </div>
            <div class="form-group col-md-4">
                <label for="pontuacao">External ID</label>
                <input type="number" class="form-control" name="externalId" placeholder="External ID" v-model="model.externalId" required />
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ignoraPontuacaoPadrao" class="custom-control-input" v-model="model.ignoraPontuacaoPadrao">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Lança nota de 0 a 10?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="meioCurso" class="custom-control-input" v-model="model.meioCurso">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Meio de Curso?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="salaAula" class="custom-control-input" v-model="model.salaAula">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Sala de Aula?</span>
                </label>
            </div>
            <div class="form-group col-md-4">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="excluido" class="custom-control-input" v-model="model.excluido">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Excluído?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <label class="custom-control" style="padding-left: 0px">Anexar Prova</label>
                <input id="arquivoProva" name="arquivoProva" style="padding-left: 15px; width: 100%" type="file" @change="handleSelectedTestFile" accept="application/pdf" />
                <small class="pull-right">Somente arquivos em PDF</small>
            </div>
            <div class="form-group col-md-12" v-if="model.nomeArquivoProvaOriginal && podeExcluirArquivoProva">
                <label class="custom-control" style="padding-left: 0px">
                    Prova Armazenada: <strong>{{model.nomeArquivoProvaOriginal}}</strong> &nbsp;
                    <button type="button" class="btn btn-sm btn-danger" @click="deleteFileFromStorage(model, 'PROVA')" v-b-tooltip title="Excluir arquivo da prova (não é preciso clicar em Salvar)">
                        <i class="fa fa-trash"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary" @click="downloadFileFromStorage(model, 'PROVA')" v-b-tooltip title="Realizar download do arquivo" style="margin-left: 5px">
                        <i class="fa fa-download"></i>
                    </button>
                </label>
            </div>
            <div class="form-group col-md-12">
                <label class="custom-control" style="padding-left: 0px">Anexar Gabarito</label>
                <input id="arquivoGabaritoProva" name="arquivoGabaritoProva" style="padding-left: 15px; width: 100%" type="file" @change="handleSelectedAnswerKeyFile" accept="application/pdf" />
                <small class="pull-right">Somente arquivos em PDF</small>
            </div>
            <div class="form-group col-md-12" v-if="model.nomeArquivoGabaritoProvaOriginal && podeExcluirArquivoGabarito">
                <label class="custom-control" style="padding-left: 0px">
                    Gabarito Armazenado: <strong>{{model.nomeArquivoGabaritoProvaOriginal}}</strong> &nbsp;
                    <button type="button" class="btn btn-sm btn-danger" @click="deleteFileFromStorage(model, 'GABARITO')" v-b-tooltip title="Excluir arquivo do gabarito (não é preciso clicar em Salvar)">
                        <i class="fa fa-trash"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary" @click="downloadFileFromStorage(model, 'GABARITO')" v-b-tooltip title="Realizar download do arquivo" style="margin-left: 5px">
                        <i class="fa fa-download"></i>
                    </button>
                </label>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estagioavaliacao-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            podeExcluirArquivoProva: false,
            podeExcluirArquivoGabarito: false,

            model: {

            },

            form: "estagioavaliacao-form-edit",

            resources: {
                edit: 'estagioavaliacao',
                deleteFile: 'estagioavaliacao/excluirarquivostorage',
                getStringBase64FromFile: 'estagioavaliacao/obterstringbase64arquivoanexado',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso.");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

            handleSelectedTestFile(event) {
                if (event.target.files && event.target.files[0]) {
                    var file = event.target.files[0];

                    if (!file)
                        return false;

                    if (file.type != "application/pdf") {
                        this.defaultErrorResult("O arquivo de prova selecionado não está em formato PDF. Por favor, revise.");
                        document.getElementById("arquivoProva").value = "";
                        return false;
                    }

                    var reader = new FileReader();
                    reader.readAsBinaryString(file);

                    reader.onload = () => {
                        this.model.arquivoProvaBase64 = btoa(reader.result);
                        this.model.nomeArquivoProvaOriginal = file.name;

                        this.podeExcluirArquivoProva = false;
                    };
                }
            },

            handleSelectedAnswerKeyFile(event) {
                if (event.target.files && event.target.files[0]) {
                    var file = event.target.files[0];

                    if (!file)
                        return false;

                    if (file.type != "application/pdf") {
                        this.defaultErrorResult("O arquivo de gabarito selecionado não está em formato PDF. Por favor, revise.");
                        document.getElementById("arquivoGabaritoProva").value = "";
                        return false;
                    }

                    var reader = new FileReader();
                    reader.readAsBinaryString(file);

                    reader.onload = () => {
                        this.model.arquivoGabaritoProvaBase64 = btoa(reader.result);
                        this.model.nomeArquivoGabaritoProvaOriginal = file.name;

                        this.podeExcluirArquivoGabarito = false;
                    };
                }
            },

            deleteFileFromStorage: function (model, fileType) {

                model.attributeBehavior = this.getDeleteBehavior(fileType);

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.deleteFile).put(model).then(data => {
                    this.defaultSuccessResult("Arquivo excluído com sucesso.");
                    this.model = data.data;
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            downloadFileFromStorage: function (model, fileType) {

                model.attributeBehavior = this.getDownloadBehavior(fileType);

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.getStringBase64FromFile).post(model).then(result => {

                    if (result == null || result.data == null)
                        return;

                    var textoDecodificado = atob(result.data);
                    var tamanhoTexto = textoDecodificado.length;
                    var bytes = new Uint8Array(tamanhoTexto);

                    for (var i = 0; i < tamanhoTexto; i++) {
                        var ascii = textoDecodificado.charCodeAt(i);
                        bytes[i] = ascii;
                    }

                    var blobArquivoRealizarDownload = new Blob([bytes], { type: "application/pdf" });

                    var urlBaixarArquivo = window.URL.createObjectURL(blobArquivoRealizarDownload);
                    var link = document.createElement('a');

                    document.body.appendChild(link);
                    link.href = urlBaixarArquivo;
                    link.download = this.getOriginalFileName(fileType, model);
                    link.click();

                    window.URL.revokeObjectURL(urlBaixarArquivo);
                    link.remove();

                    this.defaultSuccessResult("Arquivo baixado com sucesso.");

                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            getDeleteBehavior: function (fileType) {
                return fileType == "PROVA" ? "ExcluirArquivoProvaStorage" : fileType == "GABARITO" ? "ExcluirArquivoGabaritoProvaStorage" : "";
            },
            getDownloadBehavior: function (fileType) {
                return fileType == "PROVA" ? "ObterBytesArquivoProva" : fileType == "GABARITO" ? "ObterBytesArquivoGabaritoProva" : "";
            },
            getOriginalFileName: function (fileType, model) {
                return fileType == "PROVA" ? model.nomeArquivoProvaOriginal : fileType == "GABARITO" ? model.nomeArquivoGabaritoProvaOriginal : "";
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ estagioAvaliacaoId: this.id }).then(data => {
                if (data.data) {
                    this.model = data.data;
                }
                else if (!data.dataList) {
                    this.model = {};
                }
                else if (data.dataList.length == 1) {
                    this.model = data.dataList[0];
                    this.podeExcluirArquivoProva = this.model.nomeArquivoProvaOriginal != null && this.model.nomeArquivoProvaOriginal != "";
                    this.podeExcluirArquivoGabarito = this.model.nomeArquivoGabaritoProvaOriginal != null && this.model.nomeArquivoGabaritoProvaOriginal != "";
                }
                else {
                    this.model = {};
                }
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>